import { Link } from 'wouter';
import { useAdminStatus } from '../../lib/admin/useAdminStatus';
import { ADMIN_ENTRY } from '../../lib/shell/navigation';

/**
 * The **Admin Panel** button on the customer dashboard.
 *
 * This is how an administrator reaches the console in production: not from a
 * navigation item on every authenticated page, but from one button in the
 * dashboard header (spec §1). The label is production's, exactly.
 *
 * **Asked through the same hook `RequireAdmin` uses**, so the button and the
 * guard cannot disagree — an entry that appears for someone the guard then
 * refuses is worse than no entry. Rendered only on an affirmative answer, so
 * `checking`, an error, and a refusal all leave it absent and a
 * non-administrator is never told the console exists.
 */
export function AdminPanelEntry() {
  const status = useAdminStatus();

  if (status !== 'admin') return null;

  return (
    <Link
      href={ADMIN_ENTRY.href}
      data-testid="dashboard-admin-panel"
      className="inline-flex shrink-0 items-center rounded-md border border-border px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-secondary/60 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      {ADMIN_ENTRY.label}
    </Link>
  );
}
